// extracted by mini-css-extract-plugin
export default {"readMoreBtn":"ReadMore_readMoreBtn__y-GDI"};